export default function RodoPageEn() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h2>GDPR Information</h2>

      <h3>1. Data Controller</h3>
      <p>
        Art Rafał Tołczyk<br />
        Email: kontakt@arttolczyk.pl
      </p>

      <h3>2. Data Processed</h3>
      <p>
        We process only the data required to complete orders:
      </p>
      <ul>
        <li>Name and surname</li>
        <li>Email address</li>
        <li>Delivery address</li>
        <li>Order contents</li>
      </ul>

      <h3>3. Purpose</h3>
      <p>
        Data is used exclusively for fulfilling orders and contacting customers
        regarding their purchase.
      </p>

      <h3>4. Customer Rights</h3>
      <ul>
        <li>Access to personal data</li>
        <li>Correction of data</li>
        <li>Deletion of data</li>
        <li>Restriction of processing</li>
      </ul>

      <h3>5. Data Storage</h3>
      <p>
        Data is stored for the time required by accounting regulations.
      </p>

      <h3>6. Contact</h3>
      <p>
        Any privacy-related inquiries should be sent to:
        kontakt@arttolczyk.pl
      </p>
    </section>
  );
}

